import { OdqDateTime } from 'app/shared/model/odq-datetime.model';
import { MemberCorrespondenceType } from './member-correspondence-type.model';

export class LoadMemberCorrespondenceTypes {
  constructor(public memberId: string) { }
  static readonly type = '[MemberCorrespondenceTypes] LoadMemberCorrespondenceTypes';
}
export class LoadMemberCorrespondenceTypesSuccess {
  static readonly type = '[MemberCorrespondenceTypes] LoadMemberCorrespondenceTypesSuccess';
  constructor(public data: any[]) { }
}
export class LoadMemberCorrespondenceTypesFailure {
  static readonly type = '[MemberCorrespondenceTypes] LoadMemberCorrespondenceTypesFailure';
  constructor(public error: any) { }
}

export class ChooseMemberCorrespondenceType {
  static readonly type = '[MemberCorrespondenceTypes] ChooseMemberCorrespondenceType';
  constructor(public memberId: string, public effectiveOn: Date, public isResidenceAssigned: boolean) { }
}
export class ChooseMemberCorrespondenceTypeSuccess {
  static readonly type = '[MemberCorrespondenceTypes] ChooseMemberCorrespondenceTypeSuccess';
  constructor(public correspondenceTypeId: string, public effectiveOn: Date, public isResidenceAssigned: boolean) { }
}
export class ChooseMemberCorrespondenceTypeFailure {
  static readonly type = '[MemberCorrespondenceTypes] ChooseMemberCorrespondenceTypeFailure';
  constructor(public error: any) { }
}

export class CorrectMemberCorrespondenceType {
  static readonly type = '[MemberCorrespondenceTypes] CorrectMemberCorrespondenceType';
  constructor(public memberId: string, public effectiveOn: Date,
    public correspondenceTypeId: string, public isResidenceAssigned: boolean) { }
}
export class CorrectMemberCorrespondenceTypeSuccess {
  static readonly type = '[MemberCorrespondenceTypes] CorrectMemberCorrespondenceTypeSuccess';
  constructor(public correspondenceTypeId: string) { }
}
export class CorrectMemberCorrespondenceTypeFailure {
  static readonly type = '[MemberCorrespondenceTypes] CorrectMemberCorrespondenceTypeFailure';
  constructor(public error: any) { }
}

export class CancelMemberCorrespondenceTypeChange {
  constructor(public memberId: string, public memberCorrespondenceTypeId: string, public effectiveDate: Date) { }
  static readonly type = '[MemberCorrespondenceTypes] CancelMemberCorrespondenceTypeChange';
}
export class CancelMemberCorrespondenceTypeChangeSuccess {
  static readonly type = '[MemberCorrespondenceTypes] CancelMemberCorrespondenceTypeChangeSuccess';
  constructor(public residenceId: string) { }
}
export class CancelMemberCorrespondenceTypeChangeFailure {
  static readonly type = '[MemberCorrespondenceTypes] CancelMemberCorrespondenceTypeChangeFailure';
  constructor(public error: any) { }
}

export class CorrectMemberCorrespondenceTypeEffectiveDate {
  constructor(public memberId: string, public memberCorrespondenceType: MemberCorrespondenceType, public newEffectiveDate: OdqDateTime) { }
  static readonly type = '[MemberCorrespondenceTypes] CorrectMemberCorrespondenceTypeEffectiveDate';
}
export class CorrectMemberCorrespondenceTypeEffectiveDateSuccess {
  static readonly type = '[MemberCorrespondenceTypes] CorrectMemberCorrespondenceTypeEffectiveDateSuccess';
  constructor(public MemberCorrespondenceTypence: MemberCorrespondenceType, public newEffectiveDate: OdqDateTime) { }
}
export class CorrectMemberCorrespondenceTypeEffectiveDateFailure {
  static readonly type = '[MemberCorrespondenceTypes] CorrectMemberCorrespondenceTypeEffectiveDateFailure';
  constructor(public error: any) { }
}
